import { render, staticRenderFns } from "./DeliverySettings.vue?vue&type=template&id=feaae8c8&scoped=true&"
import script from "./DeliverySettings.vue?vue&type=script&lang=js&"
export * from "./DeliverySettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "feaae8c8",
  null
  
)

export default component.exports